export enum PermissionTypes {
  ACCOUNT_RECORDINGS = 'accountRecordings', // account has recordingStatus === 'PAID' or 'TRIAL'
  ACCOUNT_STREAMING = 'accountStreaming',
  IS_ADMIN = 'isAdmin',
  IS_SUPER_USER = 'isSuperUser',
  IS_USER = 'isUser',
  VIEW_DASHBOARD = 'viewDashboard',
  VIEW_MEETINGS = 'viewMeetings',
  VIEW_PROFILE = 'viewProfile',
  VIEW_RECORDINGS = 'viewRecordings', // both enabled/paid on account and turned on
  VIEW_ROOM_SYSTEMS = 'viewRoomSystems',
  VIEW_SETTINGS = 'viewSettings',
  VIEW_STREAMING = 'viewStreaming',
  VIEW_USERS = 'viewUsers',
}
